<template>
  <div>
    <div v-if="is_true === 1" class="body">
      <div v-for="p in products" :key="p.product_id">
        <div class="block">
          <img class="image" :src="p.picture" alt="商品"/>
          <div class="info">
            <div class="title">{{ p.name }}</div>
            <div class="desc">{{ p.pdt_desc }}</div>
            <div class="spec">
              <div class="item case">
                <span>{{ p.count }}</span
                ><span>箱</span>
              </div>
              <div class="item box">
                <span>{{ p.boxnum }}</span
                ><span>盒</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="products.length == 1" class="tip">您购买的是正品</div>
        <div
            v-if="
            p.applyauth_info &&
            (p.applyauth_info.auth_company || p.applyauth_info.auth_shopname)
          "
            :class="products.length > 1 ? 'store' : 'store-one'"
        >
          <div class="name">
            {{
              p.applyauth_info.is_company === 0
                  ? p.applyauth_info.auth_shopname
                  : p.applyauth_info.auth_company
            }}
          </div>
          <div class="url">{{ p.applyauth_info.shopweb }}</div>
          <div class="url">{{ p.applyauth_info.content }}</div>
        </div>
      </div>
      <div v-if="products.length > 1" class="tip">您购买的是正品</div>
      <!-- 跳转小程序的开放标签。文档 https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_Open_Tag.html -->
      <div style="position:fixed;bottom: 0;width: 100%" v-if="is_true === 1">
        <div style="background: white;text-align: center;width: 100%;">
          <!-- 跳转小程序的开放标签。文档 https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_Open_Tag.html -->
          <wx-open-launch-weapp id="launch-btn" username="gh_0c7547f0280e" :path="path">
            <script type="text/wxtag-template">
              <div class="jump-btn" style="margin: 0 auto;background: white;color: black;height: 65px;line-height:65px;text-align:center;width: 300px; border: none;font-size: 20px;font-weight: bold;">
                  收货人信息查询
              </div>
            </script>
          </wx-open-launch-weapp>
        </div>
<!--        <button-->
<!--                @click="activePkg"-->
<!--                class="active-btn"-->
<!--        >-->
<!--          以其他经销商身份激活防伪码红包-->
<!--        </button>-->
        <!--<button-->
                <!--@click="activePkg"-->
                <!--class="active-btn fixed"-->
        <!--&gt;-->
          <!--激活防伪红包-->
        <!--</button>-->

      </div>
    </div>
    <div v-else class="body-error">
      <div>
        <div>未找到此商品，无法领取正品红包</div>
        <div>请拨打<span style="color: #f9384d">400-836-3698</span>确认是否正品</div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import {postApi, showToast, isLogin} from "@/common";
import wx from 'weixin-js-sdk';
wx.config({
  debug: false, // 调试时可开启
  appId: 'wxb15157283e53b67e',//必须是非个人主体认证的小程序
  timestamp: 0, // 必填，填任意数字即可
  nonceStr: 'nonceStr', // 必填，填任意非空字符串即可
  signature: 'signature', // 必填，填任意非空字符串即可
  jsApiList: ['checkJsApi', 'getContext'],
  openTagList:['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
});
export default {
  name: "List",
  data() {
    return {
      box_code: "",
      products: [],
      product: {},
      show: "list",
      is_true: 1,
    };
  },
  created() {
    //获取箱码参数
    const qstring = window.location.href.substr(
        window.location.href.indexOf("?") + 1
    );
    const params = qs.parse(qstring);
    console.log("查询参数：", params);
    this.box_code = params.box_code ? params.box_code : "";
    //获取详情
    this.getBoxCodeInfo();
  },
  computed: {
    path () {
      if (!this.box_code) {
        return '';
      }
      return `/pages/splash/index?type=freight&boxcode=${this.box_code}`
    }
  },
  methods: {
    activePkg() {
      const that = this
      isLogin(that, that.box_code, function () {
        that.$router.push({
          path: "/activate",
          query: {
            box_code: that.box_code
          },
        });
      })
    },
    getBoxCodeInfo() {
      const that = this;
      if (this.box_code) {
        postApi(
            this.apiBase + "/api/fwm/getboxcodeinfo",
            {
              box_code: '1_' + this.box_code,
            },
            function (data) {
              if (data.code === 0) {
                that.products = data.data.product_list;
                // that.is_activation = data.data.is_activation;
                that.is_true = data.data.is_true;
                localStorage.setItem(
                    "box_code_product_list",
                    JSON.stringify(that.products)
                );
              } else {
                this.is_true = 0;
                showToast(data.msg);
              }
            }
        );
      } else {
        this.is_true = 0;
        showToast("箱码不能为空");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.body {
  background: #f5f3f3;
  padding-bottom: 100px;

  .block {
    height: 130px;
    padding: 0 20px;
    margin: 0 auto;
    background: #ffffff;
    display: flex;
    align-items: center;

    .image {
      width: 100px;
      height: 100px;
    }

    .info {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-left: 20px;

      .title {
        font-size: 20px;
        font-weight: bold;
      }

      .desc {
        font-size: 16px;
        margin-top: 5px;
      }

      .spec {
        display: flex;
        justify-content: flex-end;

        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 3px;
          background: #f0f2fb;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          font-size: 11.5px;
          color: #15093a;
          font-weight: bold;
        }

        .case {
        }

        .box {
          margin-left: 10px;
        }
      }
    }
  }

  .store {
    display: flex;
    flex-direction: column;
    margin: 12px;
    border-radius: 5px;
    border: 1px solid #666666;
    padding: 10px;
    background: #ffffff;

    .cert-id {
      font-size: 10px;
      font-weight: bold;
    }

    .name {
      text-align: center;
      font-size: 17px;
      color: #555555;
      font-weight: bold;
      margin-top: 10px;
    }

    .url {
      text-align: center;
      font-size: 11px;
      margin-top: 10px;
    }
  }

  .store-one {
    display: flex;
    flex-direction: column;
    margin: 12px auto;
    padding: 10px;
    width: 300px;

    .cert-id {
      font-size: 20px;
      font-weight: bold;
    }

    .name {
      font-size: 17px;
      color: #333333;
      margin-top: 10px;
      word-break: break-all;
    }

    .url {
      color: #333333;
      font-size: 15px;
      margin-top: 10px;
      word-break: break-all;
    }
  }

  .tip {
    font-weight: bold;
    font-size: 33px;
    margin: 50px auto 0 auto;
    text-align: center;
    width: 235px;
  }

  .active-btn {
    height: 65px;
    width: 100%;
    background: #ff5554;
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
    border: none;
  }
}

.body-error {
  margin: 0 auto;
  margin-top: 50%;
  display: flex;
  align-items: center;
  flex-direction: column;

  div {
    text-align: center;
    font-size: 33px;
    font-weight: bold;
  }
}
</style>
